import Setting from "./Setting.jsx";
export default function Language(){return <Setting languageOnly/>;}
